// import VideoModal from '../ModalVideo/VideoModal'
import { Link } from 'react-router-dom'
// import CountUp from 'react-countup'
// import abImg from '../../images/about/about-1/1.jpg'
import abImg2 from '../../images/about/about-1/2.jpg'

const About = (props) => {
  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <section id="about" className={'' + props.hclass}>
      <div className="about-wrap container">
        <div className="about-content">
          <div className="content">
            <h2
              className="scroll-text-animation"
              data-animation="fade_from_right"
            >
              About Apex Company
            </h2>
            <h3>High expectations for increased economic growth, commodity prices and Investments overall</h3>
            <p className="fade_bottom">
              APEX COMPANY LTD. Corporation is driven by a commitment to responsible energy production that not only meets today’s demands but also contributes to a sustainable future. Founded in 2010, our company has evolved to become a trusted name in the energy sector, known for balancing operational excellence with ethical and environmentally conscious practices. Based now in Erbil, Iraq, we operate with a global outlook, continually innovating to enhance efficiency and reduce environmental impact. We believe in an energy future that powers economic growth and enhances quality of life while preserving resources for generations to come. The protective function of these technical gases is probably the most frequent use and covers almost all sectors & Industrial gases.
            </p>
            <div>
        {/* <div class="card-header">
            <div class="number">10</div>
            <div class="anniversary-text">Anniversary</div>
        </div> */}
        <div className="card-content">
            {/* <div class="excellence">Excellence</div>
            <div class="service">Service</div> */}
            
            <div className="years-experience fade_bottom">
                <h2>10</h2>
                <p>Years experience</p>
            </div>
        </div>
    </div>
            <div className="about-btn ">
              <Link onClick={ClickHandler} to="/about" className="theme-btn">
              <span className="rolling-text">Learn More About Us</span>
                {/* <RollingText text={'Learn More About Us'} /> */}
              </Link>
            </div>
          </div>
        </div>
        <div>
          <div className="image">
            {/* <div className="image-1  poort-in-right">
              <img src={abImg2} alt="" />
            </div> */}
            <div className="image-2 poort-in-right">
              <img className="img-about" src={abImg2} alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
